import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    report: {},
    calibrationData: { reviewCycle: { scale: {} }, amount: 0 },
};

const getters = {
    report(state) {
        return state.report;
    },
    calibrationData(state) {
        return state.calibrationData;
    },
};

const actions = {
    getReport({ commit, state }, { payload: { query = {} } }) {
        return api.post(`/api/stats/get/report`, query).then(res => {
            const report = deepClone(getters.report(state));

            if (res.data.safeguarded) {
                // show error, this data can't be accessed
                report.safeguarded = true;
                commit("updateReport", { report });
                return;
            }

            if (res.data.noResuls) {
                commit("updateReport", { report: { noResults: true } });
                return;
            }

            report.safeguarded = false;
            report.results = res.data.results;
            report.noResults = res.data.noResults;
            report.settings = res.data.settings;
            report.scale = res.data.settings.scale;
            report.source = res.data.settings.source;

            if (query.source !== "feedback" && !query.filters?.primary?.reviewCycles?.length) {
                report.reviewCyclesWithAccess = res.data.settings?.reviewCyclesWithAccess;
            }

            commit("updateReport", { report });
        });
    },
    getCalibrationData({ commit }, { payload: { _id } }) {
        return api.get(`/api/reviewcycles/calibrationdata/${_id}`).then(res => {
            const calibrationData = res?.data ?? {};

            commit("updateCalibrationData", { calibrationData });
        });
    },
    calibrate({ commit }, { payload: { calibrationData, amount, avg, yCoordinate, xCoordinate } }) {
        commit("updateCalibrationData", { calibrationData });
        commit("updateCalibratedValue", { amount, avg, yCoordinate, xCoordinate });

        return api.post(`/api/reviewcycles/calibrate`, { _id: calibrationData._id, amount });
    },
};

const mutations = {
    updateReport(state, { report }) {
        state.report = { ...report };
    },
    updateCalibrationData(state, { calibrationData }) {
        state.calibrationData = { ...calibrationData };
    },
    updateCalibratedValue(state, { yCoordinate, xCoordinate, avg }) {
        // set avgPrecalibrated

        if (
            typeof state.report.results.observations[yCoordinate].data[xCoordinate]
                .avgPrecalibrated === "undefined"
        ) {
            state.report.results.observations[yCoordinate].data[xCoordinate].avgPrecalibrated =
                state.report.results.observations[yCoordinate].data[xCoordinate].avg;
        }

        // update avg

        state.report.results.observations[yCoordinate].data[xCoordinate].avg = avg;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
